import * as echarts from 'echarts'
import request from '@/config/request.js'
import moment from 'moment'
const ApiRenewal = request.Renewal
import common from '@/components/common/'
import moethods from '@/util/tools/common_methods.js'
import { formatDate } from '@/util/tools/date.js'
import { Message } from 'element-ui'

import sseMixin from '../../../../mixins/sseMixin'
import { streamPost, streamGet } from '../../../../config/ajaxRequest.js';



export default {
    components: {
      ...common,
    },
     mixins: [sseMixin],
  data() {
    return {
      loading: false,
      streamContent: '',
      reasoningStream: '',
      showReasoning: false,
      thinkingDone: false,
      cancelStream: null, // 保存取消函数


      schoolZones: [],
      zoneId: '',
      zoneName: '',
      kpiList: [],
      kpiList1: [{ key: 'teacherInSchool', label: '在校老师', value: 0 }],
      springRenewRateYear: '',
      autumnRenewRateYear: '',
      rateYearOptions: [{
        value: '2025',
        label: '2025'
      }, {
        value: '2026',
        label: '2026'
      }],


      moethods: moethods,
      records: [],
      records1: [],
      classAttendAnalysisByMonthList: [],
      zoneAttendAnalysisByMonthList: {},
      paginations1: {
        current_page: 1,
        total: 0,
        page_size: 9,
        page_sizes: [10, 20, 30],
        layout: 'total,  pager'
      },
      classAttendMonth: moment().format('YYYY-MM'),

      zoneTeacherAttendAnalysisByMonthList: {},
      teacherAttendDetailByMonthRangeList: [],
      teacherAttendMonth: moment().format('YYYY-MM'),
      paginations2: {
        current_page: 1,
        total: 0,
        page_size: 9,
        page_sizes: [10, 20, 30],
        layout: 'total,  pager'
      },

      
      EnrollmentYear: moment().format('YYYY'),
      zoneEnrollmentMarketingByYear: {},
      zoneEnrollmentMarketingDetailByYear: [],
      zoneEnrollmentMarketingTypeProportionByYear: {},
      // zoneEnrollmentMarketingViewsTrendByYear: {},
      typeString: {
          'activity': '招生宝',
          'cut': '砍价宝',
          'group': '拼团宝',
          'question': '问卷宝',
        },
      paginations3: {
        current_page: 1,
        total: 0,
        page_size: 8,
        page_sizes: [10, 20, 30],
        layout: 'total,  pager'
      },


      clueYear: moment().format('YYYY'),
      zoneClueSourceStatistical:{},


      zoneInsurances: [],
      paginations4: {
        current_page: 1,
        total: 0,
        page_size: 4,
        page_sizes: [10, 20, 30],
        layout: 'total,  pager'
      },

      accounts: [],
      paginations5: {
        current_page: 1,
        total: 0,
        page_size: 4,
        page_sizes: [10, 20, 30],
        layout: 'total,  pager'
      },

      integral: {},
      campusInfo: {},

      trainingYear: moment().format('YYYY'),
      trainingAnnual: [],
      trainingSummary: {},


      
      aiText: '',
      chartInstances: {
        participation: null,
        monthly: null,
        score: null,
        typePie: null,
        leadSource: null,
        leadPie: null
      },
      schoolsSettingInfo: {
        noonCareCapacity: 0,
        eveningCareCapacity: 0,
        area: 0
      }
    }
  },
  computed: {
    kpiColStyle() {
      const len = (this.kpiList && this.kpiList.length) ? this.kpiList.length : 1
      const w = (100 / len).toFixed(6) + '%'
      return { flex: '0 0 ' + w, maxWidth: w }
    },
    kpiTwoColStyle() {
      const w = (100 / 7 * 2).toFixed(6) + '%'
      return { flex: '0 0 ' + w, maxWidth: w }
    }
  },
   async mounted() {
    this.zoneId = (this.$store && this.$store.state &&
    this.$store.state.login) ? this.$store.state.login.zoneId : ''

    let str = (this.$store && this.$store.state &&
    this.$store.state.login) ? this.$store.state.login.userInfo : ''
    this.zoneName = JSON.parse(str).zoneName || ''
    await this.getAnnualListOptions()

    this.initZones()
    this.initData()
    this.getCurrentSchoolZone()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    Object.keys(this.chartInstances).forEach(k => {
      if (this.chartInstances[k]) this.chartInstances[k].dispose()
    })
  },
  methods: {
    getAnnualListOptions () {
       return new Promise((resolve) => {
          ApiRenewal.getAnnualList.call(this, {},(res) => {
            this.rateYearOptions = res.map(item => ({
              value: item || '',
              label: item || ''
            })) || []
            if (res.length) {
              this.springRenewRateYear = res[0] || ''
              this.autumnRenewRateYear = res[0] || ''
            }

          })
         resolve()
       })
      
    },
    getCurrentSchoolZone () {
      // ApiRenewal.getCurrentSchoolZone.call(this, {},(res) => {
      //   this.schoolsSettingInfo = {
      //     noonCareCapacity: res.noonCareCapacity || 0,
      //     eveningCareCapacity: res.eveningCareCapacity || 0,
      //     area: res.area || 0
      //   }
      // })
    },
    goBack() { this.$router && this.$router.go(-1) },
    async initData () {

      await this.initOverview()

      await this.initRate(1)
      await this.initRate(2)


      this.initClassAttendAnalysis()
      this.initTeacherAttendDetail()
      this.initZoneEnrollmentMarketing()
      this.initZoneClueSource()
      
      this.initZoneInsurances()
      this.initAccounts()
      this.initIntegral()
      this.initCampusInfo()

      this.initTrainingAnnual()
      window.addEventListener('resize', this.onResize)
    },

    initClassAttendAnalysis () {
      this.initClassAttendAnalysisByMonth()
      this.initZoneAttendAnalysisByMonth()
    },
    initTeacherAttendDetail() {
      this.initZoneTeacherAttendAnalysisByMonth()
      this.initTeacherAttendDetailByMonthRange()
    },
    initZoneEnrollmentMarketing(){
      this.initZoneEnrollmentMarketingByYear()
      this.initZoneEnrollmentMarketingTypeProportionByYear()
      this.initZoneEnrollmentMarketingDetailByYear()
      this.initZoneEnrollmentMarketingViewsTrendByYear()
    },
    initZoneClueSource() {
      this.initZoneClueSourceRanking()
      this.initZoneClueSourceConversionProportion()
      this.initZoneClueSourceStatistical()
    },
    onAIstartDiagnosis () {
      if (typeof this.cancelStream === 'function') this.cancelStream()
      this.streamContent = ''
      const rateToDecimal = (v) => {
        const s = String(v == null ? '' : v).trim()
        if (s.endsWith('%')) {
          return parseFloat(s.slice(0, -1)) || 0
        }
        const n = Number(v)
        return Number.isFinite(n) ? n : 0
      }
      let str = {
      "inSchoolStudentCount": parseInt(this.kpiList.find(k => k.key === 'studentInSchool').value || 0),
      "inSchoolTeacherCount": parseInt(this.kpiList1.find(k => k.key === 'teacherInSchool').value || 0),
      "inServiceStudentCount": parseInt(this.kpiList.find(k => k.key === 'studentInService').value || 0),
      "zoneStudyClassCount": parseInt(this.kpiList.find(k => k.key === 'classInSchool').value || 0),    
      "noonServiceFullRate": rateToDecimal(this.kpiList.find(k => k.key === 'noonCareFullRate').value),
      "eveningServiceFullRate": rateToDecimal(this.kpiList.find(k => k.key === 'eveningCareFullRate').value),
      "springRenewalRate": rateToDecimal(this.kpiList.find(k => k.key === 'springRenewRate').value),
      "autumnRenewalRate": rateToDecimal(this.kpiList.find(k => k.key === 'autumnRenewRate').value),
      "growthPoints": this.integral?.points || 0,
      "provinceRankByPoints": this.integral?.provinceRank || 0,
      "nationalRankByPoints": this.integral?.nationalRank || 0,
      "studentNoonAttendanceRate": this.zoneAttendAnalysisByMonthList.noonAttendRate || 0,
      "studentEveningAttendanceRate": this.zoneAttendAnalysisByMonthList.eveningAttendRate || 0,
      // "studentLeaveRate": this.zoneAttendAnalysisByMonthList.leaveCount || 0,
      "studentAvgLeaveCount": this.zoneAttendAnalysisByMonthList.leaveCount || 0,

      // "teacherSignInRate": this.zoneTeacherAttendAnalysisByMonthList.signRate || 0,
      // "teacherSignOutRate": this.zoneTeacherAttendAnalysisByMonthList.signOutRate || 0,
      // "teacherLateRate": this.zoneTeacherAttendAnalysisByMonthList.lateRate || 0,
      // "teacherEarlyLeaveRate": this.zoneTeacherAttendAnalysisByMonthList.leaveEarlyRate || 0,
      // "teacherLeaveRate": this.zoneTeacherAttendAnalysisByMonthList.leaveRate || 0,
      "teacherMaxAttendanceDays": this.zoneTeacherAttendAnalysisByMonthList.maxAttendanceDays || 0,
      "teacherMinAttendanceDays": this.zoneTeacherAttendAnalysisByMonthList.minAttendanceDays || 0, 
      "teacherMaxLateCount": this.zoneTeacherAttendAnalysisByMonthList.maxLateCount || 0,
      "teacherMaxEarlyLeaveCount": this.zoneTeacherAttendAnalysisByMonthList.maxLeaveEarlyCount || 0,


      "marketingCampaignPublishCount": this.zoneEnrollmentMarketingByYear?.totalPost || 0,
      "marketingCampaignTotalViews": this.zoneEnrollmentMarketingByYear?.totalView || 0,
      "marketingCampaignTotalShares": this.zoneEnrollmentMarketingByYear?.totalTransfer || 0,
      "marketingCampaignTotalRegistrations": this.zoneEnrollmentMarketingByYear?.totalSignup || 0,
      "marketingCampaignConversionRate": this.zoneEnrollmentMarketingByYear?.convertRate || 0,
      "marketingCampaignTotalRevenue": this.zoneEnrollmentMarketingByYear?.totalIncome || 0,
      "totalLeadsCount": this.zoneClueSourceStatistical?.totalConsult || 0,
      "leadsRegistrationCount": this.zoneClueSourceStatistical?.enrollNum || 0,
      "leadsConversionRate": this.zoneClueSourceStatistical?.consultRate || 0,
      "trainingSessionsCount": this.trainingSummary?.sessionCount || 0,
      "trainingParticipantsCount": this.trainingSummary?.participantCount || 0,
      "teacherTrainingRate": this.trainingSummary?.teacherRate || 0,
      "principalTrainingRate": this.trainingSummary?.principalRate || 0,
      "zoneId": this.zoneId || 0,
      }
      // console.log(str)
      // return
      // ApiRenewal.getAIOverview.call(this, {templateCategory: str},(data) => {
      //   console.log(data)
      // })

      this.loading = true
       this.streamContent = ''
       this.reasoningStream = ''
       this.cancelStream = streamGet(
      'https://angelbell.anqinyun.com/app/rest/school/auth/dashboard/aiOperationDiagnosis',
      { 
        metrics: JSON.stringify(str),
        templateCategory: 'OPERATION_DIAGNOSIS'
      },
      (data) => {
        const full = data && data.full
        const delta = typeof data === 'string'
          ? data
          : ((data && data.content) || (data && data.message && data.message.content) || '')
        const rc = data && data.reasoning_content

        const hasMain = (typeof delta === 'string' && delta) || (data && data.done && typeof full === 'string')
        if (hasMain) {
          if (typeof delta === 'string' && delta) {
            this.streamContent += delta
          }
          if (data && data.done && typeof full === 'string') {
            this.streamContent = full
          }
          this.thinkingDone = true
          this.showReasoning = false
        } else if (typeof rc === 'string' && rc) {
          this.reasoningStream += rc
          if (!this.thinkingDone) this.showReasoning = true
        }
      },
      (err) => { // 错误回调
        console.error('流式请求错误：', err);
      },
      () => { // 流结束回调
        this.loading = false
        console.log('流式请求完成2');
      }
    );

      // 初始化 SSE 连接
      // this.initSSE('https://angelbell.anqinyun.com/app/rest/school/auth/dashboard/aiOperationDiagnosis?templateCategory=OPERATION_DIAGNOSIS', {
      //   headers: { 'X-Custom-Header': 'vue2-sse' }
      // })
      // // 监听流式数据
      // this.$on('sse-message', (data) => {
      //   this.streamContent += data.content
      // })
      // // 监听错误
      // this.$on('sse-error', (err) => {
      //   this.closeSSE()
      //   console.error('组件内 SSE 错误：', err)
      // })
    },


    selectCommand (zoneId) {
      this.zoneId = zoneId
      this.zoneName = this.schoolZones.find(z => z.zoneId === zoneId).zoneName || ''
      this.initData()
    },
    initZones () {
      var zoneTeacher = (this.$store && this.$store.state &&
        this.$store.state.login) ? this.$store.state.login.zoneTeacher : null
      var accountId = ''
      try {
        var obj = (typeof zoneTeacher === 'string') ? JSON.parse(zoneTeacher) : zoneTeacher
        accountId = (obj && obj.teacher && obj.teacher.accountId)
          ? obj.teacher.accountId : ''
      } catch (e) {
        accountId = ''
      }
      if (!accountId) {
        this.schoolZones = []
        return
      }
      ApiRenewal.getZones.call(this, { accountId: accountId }, (data) => {
        this.schoolZones = data
      })
    },
    initRate (type) {
      if (type === 1) {
         return new Promise((resolve) => {
         
          ApiRenewal.getSpringRenewRateByYear.call(this, { year: this.springRenewRateYear }, (data) => {
            this.kpiList.forEach(item => {
              if (item.key === "springRenewRate") {
                item.value = (Number(data.springRenewRate) || 0).toFixed(2)+ '%'
              }
            })
          })
         resolve()
       })
      }
      if (type === 2) {
         return new Promise((resolve) => {
          console.log(1)
          ApiRenewal.getAutumnRenewRateByYear.call(this, { year: this.autumnRenewRateYear }, (data) => {
            this.kpiList.forEach(item => {
              if (item.key === "autumnRenewRate") {
                item.value = (Number(data.autumnRenewRate) || 0).toFixed(2)+ '%'
              }
            })
          })
         resolve()
       })
      }
      

    },
    initOverview () {
      return new Promise((resolve) => {
        ApiRenewal.getOverview.call(this, {zoneId: this.zoneId},(data) => {
          const labelMap = {
            autumnRenewRate: '秋季续费率',
            classInSchool: '校区班级',
            eveningCareFullRate: '晚托满员率',
            noonCareFullRate: '午托满员率',
            springRenewRate: '春季续费率',
            studentInSchool: '在校学生',
            studentInService: '服务期内学生',
            teacherInSchool: '在校老师'
          }
          const rateKeys = [
            // 'autumnRenewRate',
            'eveningCareFullRate',
            'noonCareFullRate',
            // 'springRenewRate'
          ]
          const keys = [
            'studentInSchool',
            'studentInService',
            'classInSchool',
            'noonCareFullRate',
            'eveningCareFullRate',
            'springRenewRate',
            'autumnRenewRate'
          ]
          const fmt = (k, v) => {
            if (rateKeys.includes(k)) {
              const n = Number(v || 0)
              return (Number.isFinite(n) ? n.toFixed(2) : '0') + '%'
            }
            return String(v == null ? 0 : v)
          }
          const list = keys.map(k => ({
            key: k,
            label: labelMap[k],
            value: fmt(k, data && data[k])
          }))
          const teacher = {
            key: 'teacherInSchool',
            label: labelMap.teacherInSchool,
            value: String((data && data.teacherInSchool) || 0)
          }
          this.kpiList = list
          this.kpiList1 = [teacher]
          resolve()
        })
      })
      // ApiRenewal.getOverview.call(this, {zoneId: this.zoneId},(data) => {
      //   const labelMap = {
      //     autumnRenewRate: '秋季续费率',
      //     classInSchool: '校区班级',
      //     eveningCareFullRate: '晚托满员率',
      //     noonCareFullRate: '午托满员率',
      //     springRenewRate: '春季续费率',
      //     studentInSchool: '在校学生',
      //     studentInService: '服务期内学生',
      //     teacherInSchool: '在校老师'
      //   }
      //   const rateKeys = [
      //     // 'autumnRenewRate',
      //     'eveningCareFullRate',
      //     'noonCareFullRate',
      //     // 'springRenewRate'
      //   ]
      //   const keys = [
      //     'studentInSchool',
      //     'studentInService',
      //     'classInSchool',
      //     'noonCareFullRate',
      //     'eveningCareFullRate',
      //     'springRenewRate',
      //     'autumnRenewRate'
      //   ]
      //   const fmt = (k, v) => {
      //     if (rateKeys.includes(k)) {
      //       const n = Number(v || 0)
      //       return (Number.isFinite(n) ? n.toFixed(2) : '0') + '%'
      //     }
      //     return String(v == null ? 0 : v)
      //   }
      //   const list = keys.map(k => ({
      //     key: k,
      //     label: labelMap[k],
      //     value: fmt(k, data && data[k])
      //   }))
      //   const teacher = {
      //     key: 'teacherInSchool',
      //     label: labelMap.teacherInSchool,
      //     value: String((data && data.teacherInSchool) || 0)
      //   }
      //   this.kpiList = list
      //   this.kpiList1 = [teacher]
      // })
    },

    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'warning-row' : ''
    },
    onResize() {
      Object.values(this.chartInstances).forEach(i => {
        if (i) i.resize()
      })
    },

    initClassAttendAnalysisByMonth () {
      let param = {
        offset: (this.paginations1.current_page - 1) * this.paginations1.page_size,
        limit: this.paginations1.page_size,
        "data": {
          "zoneId": this.zoneId,
          "startDate": this.classAttendMonth ? moment(this.classAttendMonth).endOf('month').format('YYYY-MM-01') : moment().format('YYYY-MM-01'),
          "endDate": this.classAttendMonth ? moment(this.classAttendMonth).endOf('month').format('YYYY-MM-31') : moment().format('YYYY-MM-31')
        },
        "filters": null,
        "orFilters": null,
        "order": "desc",
        "sort": "studyClassId"
      }
      ApiRenewal.getClassAttendAnalysisByMonth.call(this, param,(data) => {
        this.classAttendAnalysisByMonthList = data.content || []
        this.paginations1.total = parseInt(data.totalElements) || 0
      })
    },
    initZoneAttendAnalysisByMonth () {
      let param = {
          "zoneId": this.zoneId,
          "startDate": this.classAttendMonth ? moment(this.classAttendMonth).endOf('month').format('YYYY-MM-01') : moment().format('YYYY-MM-01'),
          "endDate": this.classAttendMonth ? moment(this.classAttendMonth).endOf('month').format('YYYY-MM-31') : moment().format('YYYY-MM-31')
        }
      ApiRenewal.getZoneAttendAnalysisByMonth.call(this, param,(data) => {
        this.zoneAttendAnalysisByMonthList = data || {}
      })
    },
    initZoneTeacherAttendAnalysisByMonth () {
      let param = {
          "zoneId": this.zoneId,
          "startDate": this.teacherAttendMonth ? moment(this.teacherAttendMonth).endOf('month').format('YYYY-MM-01') : moment().format('YYYY-MM-01'),
          "endDate": this.teacherAttendMonth ? moment(this.teacherAttendMonth).endOf('month').format('YYYY-MM-31') : moment().format('YYYY-MM-31')
        }
      ApiRenewal.getZoneTeacherAttendAnalysisByMonth.call(this, param,(data) => {
        this.zoneTeacherAttendAnalysisByMonthList = data || {}
      })
    },
    initTeacherAttendDetailByMonthRange () {
      let param = {
        offset: (this.paginations2.current_page - 1) * this.paginations2.page_size,
        limit: this.paginations2.page_size,
        "data": {
          "zoneId": this.zoneId,
          "startDate": this.teacherAttendMonth ? moment(this.teacherAttendMonth).endOf('month').format('YYYY-MM-01') : moment().format('YYYY-MM-01'),
          "endDate": this.teacherAttendMonth ? moment(this.teacherAttendMonth).endOf('month').format('YYYY-MM-31') : moment().format('YYYY-MM-31')
        },
        "filters": null,
        "orFilters": null,
        "order": "desc",
        "sort": "teacherId"
      }
      ApiRenewal.getPageTeacherAttendDetailByMonthRange.call(this, param,(data) => {
        this.teacherAttendDetailByMonthRangeList = data.content || []
        this.paginations2.total = parseInt(data.totalElements) || 0
      })
    },
    initZoneEnrollmentMarketingByYear () {
      let param = {
        "zoneId": this.zoneId,
        "startDate": this.EnrollmentYear ? moment(this.EnrollmentYear).endOf('year').format('YYYY-01-01') : moment().format('YYYY-01-01'),
        "endDate": this.EnrollmentYear ? moment(this.EnrollmentYear).endOf('year').format('YYYY-12-31') : moment().format('YYYY-12-31')
        }
      ApiRenewal.getZoneEnrollmentMarketingByYear.call(this, param,(data) => {
        this.zoneEnrollmentMarketingByYear = data || {}
      })
    },
    initZoneEnrollmentMarketingTypeProportionByYear () {
      let param = {
        "zoneId": this.zoneId,
        "startDate": this.EnrollmentYear ? moment(this.EnrollmentYear).endOf('year').format('YYYY-01-01') : moment().format('YYYY-01-01'),
        "endDate": this.EnrollmentYear ? moment(this.EnrollmentYear).endOf('year').format('YYYY-12-31') : moment().format('YYYY-12-31')
        }
      ApiRenewal.getZoneEnrollmentMarketingTypeProportionByYear.call(this, param,(res) => {
        const el = this.$refs.leadPieChart
        if (!el) return
        const chart = echarts.init(el)
        this.chartInstances.leadPie = chart
        
      
        const data = res.items?.map(item => ({ name: this.typeString[item.path], value: item.count })) || []
        chart.setOption({
          title : {
            text: '招生发布类型',
            x:'left',
            textStyle: { color: '#cfe3ff' },
          },
          legend: { bottom: 0, textStyle: { color: '#8aa4c9' } },
          calculable : true,
          series: [
            { type: 'pie',
              radius: ['0','50%'],

              roseType : 'radius',
              selectedMode: 'single',
              data,
              label: { formatter: '{d}%', color: '#cfe3ff' },
              itemStyle: { color: (p) => ['#4f8ef7','#22c55e','#f59e0b','#ef4444','#8b5cf6','#14b8a6'][p.dataIndex] } }
          ]
        })
      })
    },
    initZoneEnrollmentMarketingDetailByYear () {
      let param = {
        offset: (this.paginations3.current_page - 1) * this.paginations3.page_size,
        limit: this.paginations3.page_size,
        "data": {
          "zoneId": this.zoneId,
          "startDate": this.EnrollmentYear ? moment(this.EnrollmentYear).endOf('year').format('YYYY-01-01') : moment().format('YYYY-01-01'),
          "endDate": this.EnrollmentYear ? moment(this.EnrollmentYear).endOf('year').format('YYYY-12-31') : moment().format('YYYY-12-31')
        },
        "filters": null,
        "orFilters": null,
        "order": "",
        "sort": ""
      }
      ApiRenewal.getZoneEnrollmentMarketingDetailByYear.call(this, param,(res) => {
        this.zoneEnrollmentMarketingDetailByYear = res.content || []
        this.paginations3.total = parseInt(res.totalElements) || 0
      })
    },
    initZoneEnrollmentMarketingViewsTrendByYear () {
      let param = {
        "zoneId": this.zoneId,
        "startDate": this.EnrollmentYear ? moment(this.EnrollmentYear).endOf('year').format('YYYY-01-01') : moment().format('YYYY-01-01'),
        "endDate": this.EnrollmentYear ? moment(this.EnrollmentYear).endOf('year').format('YYYY-12-31') : moment().format('YYYY-12-31')
        }
      ApiRenewal.getZoneEnrollmentMarketingViewsTrendByYear.call(this, param,(res) => {
        // this.zoneEnrollmentMarketingViewsTrendByYear = res || {}

        const el = this.$refs.marketingChart
      if (!el) return
      const chart = echarts.init(el)
      this.chartInstances.marketing = chart
    
      const items = Array.isArray(res.items) ? res.items.slice().sort((a, b) => (a.month - b.month)) : []

      const months = items?.map(i => (i && i.month != null) ? (i.month + '月') : '-') || []
      const values = items?.map(i => (i && i.views != null) ? Number(i.views) : 0) || []
      chart.setOption({
        grid: { left: 60, right: 20, top: 70, bottom: 20 },
        title : {
          text: '月度浏览趋势',
          x:'left',
          textStyle: { color: '#cfe3ff' },
        },
        tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              const date = params[0].name
              const value = params[0].value
              return `${date}<br>浏览数量: ${value}`
            },
          },
        
        xAxis: {
          type: 'category',
          data: months,
          axisLabel: { color: '#8aa4c9' },
          axisLine: { lineStyle: { color: '#274063' } },
          axisTick: { lineStyle: { color: '#274063' } }
        },
        yAxis: {
          type: 'value',
          // name: '月度浏览趋势',
          nameTextStyle: { color: '#8aa4c9' },
          axisLabel: { color: '#8aa4c9' },
          axisLine: { lineStyle: { color: '#274063' } },
          axisTick: { lineStyle: { color: '#274063' } },
          splitLine: { lineStyle: { color: '#1c2f4a' } }
        },
        series: [
          { type: 'bar', data: values, barWidth: 20, itemStyle: { color: '#4f8ef7' } }
        ]
      })
      })
    },

    initZoneClueSourceRanking () {
      let param = {
        "zoneId": this.zoneId,
        "startDate": this.clueYear ? moment(this.clueYear).endOf('year').format('YYYY-01-01') : moment().format('YYYY-01-01'),
        "endDate": this.clueYear ? moment(this.clueYear).endOf('year').format('YYYY-12-31') : moment().format('YYYY-12-31')
        }
      ApiRenewal.getZoneClueSourceRanking.call(this, param,(res) => {
        // this.zoneClueSourceRanking = res || {}

        const el = this.$refs.leadSourceChart
      if (!el) return
      const chart = echarts.init(el)
      this.chartInstances.leadSource = chart

      const categories = res.items?.map(item => item.label) || []
      const values = res.items?.map(item => item.count) || []
      chart.setOption({
        grid: { left: 90, right: 50, top: 30, bottom: 30 },
         tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              const date = params[0].name
              const value = params[0].value
              return `${date}<br>数量: ${value}`
            },
          },
        title : {
          text: '线索来源',
          x:'left',
          textStyle: { color: '#cfe3ff' ,fontSize: 12 },
        },
        xAxis: {
          type: 'value',
          axisLabel: { color: '#8aa4c9' },
          axisLine: { lineStyle: { color: '#274063' } },
          splitLine: { lineStyle: { color: '#1c2f4a' } } },
        yAxis: {
          type: 'category',
          // name: '线索来源',
          data: categories,
          axisLabel: { color: '#8aa4c9' },
          axisLine: { lineStyle: { color: '#8aa4c9' } } },
        series: [
          { type: 'bar', data: values, barWidth: 18, itemStyle: { color: '#4f8ef7' }, label: { show: true, position: 'right', color: '#cfe3ff' } }
        ]
      })
      })
    },
    initZoneClueSourceConversionProportion () {
      let param = {
        "zoneId": this.zoneId,
        "startDate": this.clueYear ? moment(this.clueYear).endOf('year').format('YYYY-01-01') : moment().format('YYYY-01-01'),
        "endDate": this.clueYear ? moment(this.clueYear).endOf('year').format('YYYY-12-31') : moment().format('YYYY-12-31')
        }
      ApiRenewal.getZoneClueSourceConversionProportion.call(this, param,(res) => {
        // this.zoneClueSourceConversionProportion = res || {}
        const el = this.$refs.leadPieChart1
      if (!el) return
      const chart = echarts.init(el)
      this.chartInstances.leadPie = chart
      const data = res.items?.map(item => ({ name: item.label, value: item.appliedCount })) || []
      chart.setOption({
        title : {
          text: '线索来源转化占比',
          x:'left',
          textStyle: { color: '#cfe3ff' },
        },
        tooltip: {
            trigger: 'item'
          },
        legend: { bottom: 0, textStyle: { color: '#8aa4c9' } },

        calculable : true,
        series: [
          { type: 'pie',
            radius: ['20%','50%'],
            roseType : 'radius',
            selectedMode: 'single',
            data,
            label: { formatter: '{b}: {c} ({d}%)', color: '#cfe3ff' },
            itemStyle: { color: (p) => ['#4f8ef7','#22c55e','#f59e0b','#ef4444','#8b5cf6','#14b8a6'][p.dataIndex] } }
        ]
      })
      })
    },
    initZoneClueSourceStatistical () {
      let param = {
        "zoneId": this.zoneId,
        "startDate": this.clueYear ? moment(this.clueYear).endOf('year').format('YYYY-01-01') : moment().format('YYYY-01-01'),
        "endDate": this.clueYear ? moment(this.clueYear).endOf('year').format('YYYY-12-31') : moment().format('YYYY-12-31')
        }
      ApiRenewal.getZoneClueSourceStatistical.call(this, param,(res) => {
        // console.log(res,'线索来源统计')
        this.zoneClueSourceStatistical = res || {}
      })
    },
    initZoneInsurances () {
      let param = {
        "zoneId": this.zoneId,
        currentPage: this.paginations4.current_page,
        pageSize: this.paginations4.page_size,
       }
      ApiRenewal.getZoneInsurances.call(this, param,(res) => {
        // console.log(res,'保险类型统计')
        this.zoneInsurances = res?.data?.list || []
        this.paginations4.total = res?.data?.pagination?.total || 0
      })
    },
    initAccounts () {
      let param = {
        "zoneId": this.zoneId,
        currentPage: this.paginations5.current_page,
        pageSize: this.paginations5.page_size,
       }
      ApiRenewal.getAccounts.call(this, param,(res) => {
        this.accounts = res?.data?.list || []
        this.paginations5.total = res?.data?.pagination?.total || 0
      })
    },
    initIntegral () {
      let param = {
        "zoneId": this.zoneId
       }
      ApiRenewal.getIntegral.call(this, param,(res) => {
        this.integral = res?.data || {}
      })
    },

    initCampusInfo () {
      let param = {
        "zoneId": this.zoneId
       }
      ApiRenewal.getCampusInfo.call(this, param,(res) => {
        this.campusInfo = res?.data || {}
      })
    },
    initTrainingAnnual () {
      let param = {
        "zoneId": this.zoneId,
        "year": this.trainingYear ? moment(this.trainingYear).format('YYYY') : moment().format('YYYY'),
        
       }
      ApiRenewal.getTrainingAnnual.call(this, param,(res) => {
        this.trainingAnnual = res?.data?.list || []
        this.trainingSummary = res?.data?.summary || {}
      })
    },
    


    initCharts() {
      this.initMarketing()
      this.initLeadSource()
      // this.initLeadPie()
      this.initLeadPie1()
    },
    initMarketing() {
      
    },
    initLeadSource() {
      
    },
    initLeadPie() {
      const el = this.$refs.leadPieChart
      if (!el) return
      const chart = echarts.init(el)
      this.chartInstances.leadPie = chart
      const data = [
        { name: '招生宝', value: 18 },
        { name: '砍价宝', value: 58 },
        { name: '拼团宝', value: 38 },
        { name: '问卷宝', value: 28 },
      ]
      chart.setOption({
        title : {
          text: '招生发布类型',
          x:'left',
          textStyle: { color: '#cfe3ff' },
        },
        legend: { bottom: 0, textStyle: { color: '#8aa4c9' } },
        calculable : true,
        series: [
          { type: 'pie',
            radius: ['0','50%'],

            roseType : 'radius',
            selectedMode: 'single',
            data,
            label: { formatter: '{d}%', color: '#cfe3ff' },
            itemStyle: { color: (p) => ['#4f8ef7','#22c55e','#f59e0b','#ef4444','#8b5cf6','#14b8a6'][p.dataIndex] } }
        ]
      })
    },
    initLeadPie1() {
      
    }
    ,fmtDate(d) {
      return formatDate(d)
    }
  }
}
